import axios, { AxiosError, AxiosResponse } from "axios";
import { readToken } from "../services/localStorage.Service";
import { PhotoModel } from "../domaine/visiteModel";

const apiUrl = process.env.REACT_APP_API_URL;

// Create an Axios instance
export const axiosInstance = axios.create({
  baseURL: apiUrl,
});

// Add Authorization header to all requests
axiosInstance.interceptors.request.use((config: any) => {
  config.headers = {
    ...config.headers,
    Authorization: `Bearer ${readToken()}`, // Add token for authorization
  };
  return config;
});

// Global error handling
axiosInstance.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (error.response) {
      console.error("HTTP error response:", error.response.data);
      return Promise.reject(error.response.data);
    } else if (error.request) {
      console.error("HTTP no response:", error.request);
      return Promise.reject({
        message: "No response received from the server",
      });
    } else {
      console.error("HTTP request setup error:", error.message);
      return Promise.reject({ message: "Error setting up the request" });
    }
  }
);

// API call to upload photos with FormData passed as a parameter
export const uploadPhotosApi = async (formData: FormData): Promise<any> => {
  try {
    // Send the POST request with the provided FormData
    const response: AxiosResponse<any> = await axiosInstance.post<any>(
      "photos/",
      formData
    );

    console.log("Upload successful:", response.data);
    return response.data;
  } catch (error: any) {
    console.error("Photo upload failed:", error);
    throw error.response?.data || { message: "Photo upload failed" };
  }
};

export const fetchPhotosByVisiteApi = async (
  visiteId: number
): Promise<any> => {
  try {
    const response: AxiosResponse<PhotoModel[]> = await axiosInstance.get<
      PhotoModel[]
    >("photos/visite/" + visiteId + "/");
    return response.data;
  } catch (error: any) {
    console.error("Fetch photos by visite failed", error);
    throw error.response?.data || "Fetch photos by visite failed";
  }
};
